import io from 'socket.io-client'

// Only auto-connect in the browser. Connecting at import time on the server
// keeps socket.io reconnection timers alive during `next build`, which hangs
// the "Collecting page data" worker and fails the build with a timeout.
const socket = io(process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL ?? '', {
  autoConnect: typeof window !== 'undefined'
})

export default socket
